<template>
  <BasicLayout>
    <template #wrapper>

      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>分组配置</span>
          <el-row :gutter="10" class="mb8" style="margin-top: 20px;">
            <el-col :span="1.5">
              <el-button v-permisaction="['config:cardInfoCfg:add']" size="mini" style="margin-top: 10px" type="primary" @click="onCommonCfg()">保存</el-button>
              <ClearCacheApply />
              <sync-data />
            </el-col>
          </el-row>
          <el-form>
            <el-row :gutter="10" class="mb8" style="margin-top: 20px;">
              <el-col span="24">
                <el-form-item label="分组(1)">
                  <el-select v-model="cardGroupInfo[1].groupIds" multiple style="width: 50%">
                    <el-option v-for="item in groupsList" :key="item.id" :value="item.id" :label="item.name" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10" class="mb8" style="margin-top: 20px;">
              <el-col span="24">
                <el-form-item label="分组(2)">
                  <el-select v-model="cardGroupInfo[2].groupIds" multiple style="width: 50%">
                    <el-option v-for="item in groupsList" :key="item.id" :value="item.id" :label="item.name" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-card>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>卡片配置</span>

          <el-row :gutter="10" class="mb8" style="margin-top: 20px;">
            <el-col :span="1.5">
              <el-upload ref="upload" class="upload-demo" :action="sys_app_logoAction" accept="xlsx" :limit="1" :on-success="(res)=>{return importUploadSuccess(res)}" :headers="headers">
                <el-button v-permisaction="['config:cardInfoCfg:import']" :loading="loading" icon="el-icon-upload2" size="mini" type="primary">导入</el-button>
              </el-upload>
            </el-col>
            <el-col :span="1.5">
              <el-button v-permisaction="['config:cardInfoCfg:export']" type="primary" icon="el-icon-download" size="mini" @click="exportData()">导出</el-button>
            </el-col>
            <el-col :span="1.5"><ClearCacheApply /> <sync-data /></el-col>
          </el-row>

        </div>

        <el-table style="border:1px solid #ccc" :data="formData" border stripe>
          <el-table-column prop="ciid" label="卡片ID">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.ciid" />
            </template>
          </el-table-column>
          <el-table-column prop="ci_name" label="卡片名">
            <template v-slot:default="scope">
              <el-input v-model="scope.row.ci_name" />
            </template>
          </el-table-column>
          <el-table-column prop="cgposition" label="卡组ID">
            <template v-slot:default="scope">
              <el-select v-model.number="scope.row.cgid" placeholder="请选择">
                <el-option v-for="item in cardGroup" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="cgposition" label="卡片在卡组位置">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.cgposition" />
            </template>
          </el-table-column>
          <el-table-column prop="ci_star_rank" label="星级">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.ci_star_rank" />
            </template>
          </el-table-column>
          <el-table-column prop="ci_lockRank" label="解锁等级">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.ci_lockRank" />
            </template>
          </el-table-column>
          <el-table-column prop="ci_lang_key" label="语言KEY">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.ci_lang_key" />
            </template>
          </el-table-column>
          <el-table-column prop="ci_star_rank" label="类型">
            <template v-slot:default="scope">
              <el-select v-model="scope.row.grade" placeholder="请选择">
                <el-option v-for="item in selectType" :key="item.id" :label="item.title" :value="item.id" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="weights" label="权重(默认)">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.weights" />
            </template>
          </el-table-column>
          <el-table-column prop="weights" label="权重(分组2)">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.weights2" />
            </template>
          </el-table-column>
          <el-table-column prop="reward" label="奖励">
            <template v-slot:default="scope">
              <Reward v-model.number="scope.row.reward" />
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template v-slot:default="scope">
              <el-button v-permisaction="['config:cardInfoCfg:del']" type="danger" @click="del(scope.row.ciid)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-button v-permisaction="['config:cardInfoCfg:add']" style="margin-top: 10px" type="primary" @click="add()">+</el-button>
        <el-button v-permisaction="['config:cardInfoCfg:add']" style="margin-top: 10px" type="primary" @click="onSubmit()">保存</el-button>

        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getToken } from '@/utils/auth'
import { delCardCfg, exportCardCfg, getCardCfgList, importCardCfg, updateCardCfg } from '@/api/config/card-cfg'
import { getCardGroupList } from '@/api/config/card-pro'
import Reward from '@/components/Reward'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import { getCommonCfg, updateCommonCfg } from '@/api/config/common-cfg'
import { getUserTypeAllList } from '@/api/config/user-group-cfg'
import SyncData from '@/components/syncData/index.vue'
export default {
  name: 'CardConfig',
  components: { SyncData, ClearCacheApply, Reward },
  data() {
    return {
      loading: false,
      langVisibleArr: [{ visible: false }],
      total: 0,
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      cardGroup: [],
      selectType: [
        { 'id': 1, 'title': '普通卡' },
        { 'id': 2, 'title': '黄金卡' }
      ],
      formData: [
        {
          'ciid': 0,
          'cgposition': 0,
          'cgid': 0,
          'ci_name': '',
          'ci_star_rank': 0,
          'ci_lockRank': 0,
          'ci_lang_key': 0,
          'grade': 1,
          'weights': 0,
          'weights2': 0
        }
      ],
      cardGroupInfo: { 1: { groups: [] }, 2: { groups: [] }},
      groupsList: []
    }
  },
  created() {
    this.initBase()
    this.getTables()
    this.getCardGroup()
  },
  methods: {
    handleClose(d, index) {
      this.langVisibleArr[index].visible = false
    },
    initBase() {
      getUserTypeAllList().then(res => {
        res.data.forEach(res => {
          this.groupsList.push({ name: res.name, id: res.groupId })
        })
      })
    },
    getCardGroup() {
      getCardGroupList().then(res => {
        if (res.code === 200) {
          res.data.forEach(item => {
            this.cardGroup.push({ label: item.cg_name, value: parseInt(item.cgid) })
          })
        } else {
          this.msgError(res.msg)
        }
      })
    },
    onSubmit() {
      const data = JSON.stringify(this.formData)
      updateCardCfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    onCommonCfg() {
      const data = []
      for (const k in this.cardGroupInfo) {
        data.push(this.cardGroupInfo[k])
      }
      updateCommonCfg({ data: JSON.stringify(data), name: 'cardInfoGroup' }).then(res => {
        this.msgSuccess(res.msg)
      })
    },
    getTables() {
      getCommonCfg({ name: 'cardInfoGroup' }).then(res => {
        for (let i = 0; i < res.data.length; i++) {
          this.cardGroupInfo[res.data[i].gid] = res.data[i]
        }
        console.log(this.cardGroupInfo)
      })
      getCardCfgList(this.queryParams).then(res => {
        this.total = res.data.count
        this.formData = res.data.list
      })
    },
    add() {
      this.formData.push({
        'ciid': 0,
        'cgposition': 0,
        'cgid': 0,
        'ci_star_rank': 0,
        'ci_lockRank': 0,
        'ci_lang_key': 0,
        'grade': 1,
        'weights': 0,
        'weights2': 0
      })
      this.langVisibleArr.push({ visible: false })
      const index = this.formData.length - 1
      // this.options[index] = []
      this.$set(this.options, index, [])
      this.getRewardList(1, index, 0)
    },
    importUploadSuccess(response) {
      this.loading = true
      this.$refs.upload.clearFiles()
      importCardCfg({ data: response.data.path }).then(res => {
        this.loading = false
        // eslint-disable-next-line eqeqeq
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    exportData() {
      exportCardCfg().then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    del(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delCardCfg({ id: id }).then(res => {
          if (res.code === 200) {
            this.msgSuccess(res.msg)
            this.getTables()
          } else {
            this.msgError(res.msg)
          }
        })
      })
    }
  }
}
</script>

<style scoped>
</style>
